import Vue from 'vue';
import global_mixin from './global_mixins.js'
import LazyBackground from '../components/LazyBackground.vue'
import '../css/series_detail.css'
var _ = require('lodash')
// import VueGallery from 'vue-gallery' 
import VueGallery from '../components/Gallery.vue'
import { getTile, tilesForColor, bookmarkedTiles } from '../graphql/queries'
import gql from 'graphql-tag'
import 'lightgallery.js'
import 'lightgallery.js/dist/css/lightgallery.css'
import 'lg-video.js'

Vue.component('lazy-background', LazyBackground)
var currentWindowLocation = window.location.pathname
var URLSearchParams = require('url-search-params')
let urlParams = new URLSearchParams(window.location.search)

const app = new Vue({
  el: '#app',
  components: {
    'gallery': VueGallery
  },
  data() {
    return {
      currentSlide: 0,
      currentTileID: null,
      currentSeriesID: 0,
      currentSeriesPolaroids: [],
      videoIndex: 0,
      slideDirection: 'right',
      isTransitioningSeries: false,
      galleryKey: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
      galleryIndex: null,
      shadeGalleryContent: [],
      shadeGalleryKey: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
      shadeGalleryIndex: null,
      tilePopupImage: null,
      tilePopupImageIndex: 0,
      polaroidLeft: 0,
      polaroidRight: 4,
      polaroidDisplayLimit: 4,
      videoUrl: null,
      content_type: null
    }
  },
  apollo: {
    currentTileQuery: {
      query: getTile,
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.clearApolloCache()
        }
        else {
          console.error(error)
        }
      },
      update: data => data.tile,
      variables() {
        return {
          id: (this.currentTileID) ? this.encodeTileID(this.currentTileID) : undefined
        }
      },
      skip() {
        return this.currentTileID === null
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
      result() {

      }
    },
    currentSeriesScenes: {
      query: gql `query allRoomScenes($before: String
        $after: String
        $first: Int
        $last: Int
        $series: [ID]
      ) {
        allRoomScenes(before: $before, after: $after, first: $first, last: $last, series: $series) {
          edges {
            node {
      				id
      				sliderLoading
      				largeImage
      				sliderImage
      				thumbnail
              position
              lightboxDescription
              featuredCommercial
              featuredResidential
              tiles{
                edges{
                  node{
                    sku
                    shape{
                      size
                    }
                  }
                }
              }
              series {
                id
                tagline
                videoEmbedUrl
              }
              featuredColor {
                name
                id
                code
                family
              }
            }
          }
        }
      }`,
      update: data => data.allRoomScenes,
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.clearApolloCache()
        }
        else {
          console.error(error)
        }
      },
      variables() {
        return {
          series: [this.currentSeriesID]
        }
      },
      skip() {
        return !this.cacheLoaded
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
      result(data) {
        let slides = []
        console.log(data)
        if (data.data.allRoomScenes.edges[0].node.series.videoEmbedUrl != '') {
          let href = data.data.allRoomScenes.edges[0].node.series.videoEmbedUrl
          let youtubeID = href.split("embed/")
          slides.push({
            href: data.data.allRoomScenes.edges[0].node.series.videoEmbedUrl,
            thumbnail: 'https://img.youtube.com/vi/'+youtubeID[1]+'/default.jpg',
            id: 'dsafdsfdsafdfdfrfafafadfsf'
          })
        }
        for (const scene of data.data.allRoomScenes.edges) {
          slides.push(scene.node)
        }
        this.currentSeriesPolaroids = slides
      }
    },
    bookmarkedTiles: {
      query: bookmarkedTiles,
      update: data => data.allTiles,
      result({ data, loading, networkStatus }) {
        data = data.allTiles
        this.sampleOrders = []
        this.$ls.set('bookmarked_sampleorder_skus', JSON.stringify(Array.from(new Set(this.bookmarked_sampleorder_skus))))
        if (data.edges && data.edges.length > 0) {
          for (const tile of data.edges) {
            if (_.find(this.sampleOrders, { 'sku': tile.node.sku }) === undefined) {
              this.addSampleToCart(tile.node)
            }
          }
        }
      },
      variables() {
        return {
          id: this.encodedBookmarks,
        }
      },
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.clearApolloCache()
        }
        else {
          console.error(error)
        }
      },
      skip() {
        return !(this.cacheLoaded && this.encodedBookmarks.length > 0)
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
    },
    tilesForColor: {
      query: tilesForColor,
      update: data => data.allColors,
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.clearApolloCache()
        }
        else {
          console.error(error)
        }
      },
      variables() {
        return {
          id: this.uniqueColorLookups,
          unavailableForSampleOrder: false,
          excludeCutSample: false
        }
      },
      skip() {
        return this.uniqueColorLookups.length === 0
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
    },
  },
  created() {
    this.loadBookmarks()
    // if (urlParams.has('residential')) {
    //   this.residentialSwitch = true
    //   this.commercialSwitch = false
    // }
    this.loadInitialData()
    this.loadComparisons()
  },
  methods: {
    setSlideDirectionLeft() {
      this.slideDirection = 'left'
      setTimeout(() => {
        this.slideDirection = 'right'
      }, 2500)
    },
    changeSlide(index) {
      if (this.currentSlide > index) {
        this.setSlideDirectionLeft()
      }
      else {
        this.slideDirection = 'right'
      }
      this.currentSlide = index

    },
    nextSlide() {
      this.slideDirection = 'right'
      if (this.currentSlide < (this.currentSeriesSlides.length - 1)) {
        this.currentSlide++
      }
    },
    previousSlide() {
      this.setSlideDirectionLeft()
      if (this.currentSlide > 0 && this.currentSlide != 0) {
        this.currentSlide--
      }
    },
    // setResidential() {
    //   if (this.residentialSwitch) {
    //     this.residentialSwitch = false
    //     this.commercialSwitch = true
    //     this.$ls.set('residential_switch', this.residentialSwitch)
    //     this.$ls.set('commercial_switch', this.commercialSwitch)
    //     window.location.href = currentWindowLocation
    //   }
    //   else {
    //     this.residentialSwitch = true
    //     this.commercialSwitch = false
    //     this.$ls.set('residential_switch', this.residentialSwitch)
    //     this.$ls.set('commercial_switch', this.commercialSwitch)
    //     window.location.href = currentWindowLocation + '?residential=true'
    //   }
    // },
    // setCommercial() {
    //   if (this.commercialSwitch) {
    //     this.residentialSwitch = true
    //     this.commercialSwitch = false
    //     this.$ls.set('residential_switch', this.residentialSwitch)
    //     this.$ls.set('commercial_switch', this.commercialSwitch)
    //   }
    //   else {
    //     this.residentialSwitch = false
    //     this.commercialSwitch = true
    //     this.$ls.set('residential_switch', this.residentialSwitch)
    //     this.$ls.set('commercial_switch', this.commercialSwitch)
    //     window.location.href = currentWindowLocation
    //   }
    // },
    previousPolaroid() {
      let slide_length_offset = this.currentSeriesPolaroids.length - 1
      let previousPolaroid = this.currentSeriesPolaroids.pop()
      this.currentSeriesPolaroids.unshift(previousPolaroid)
      if(this.videoIndex == slide_length_offset){
        this.videoIndex = 0
      } else {
        this.videoIndex++
      }
      /*if (this.polaroidLeft > 0) {
        this.polaroidLeft--
        this.polaroidRight--
      } else {
        this.polaroidRight = this.currentSeriesSlides.length - 1
        this.polaroidLeft = this.polaroidRight - this.polaroidDisplayLimit - 1
      }*/
    },
    nextPolaroid() {
      let slide_length_offset = this.currentSeriesPolaroids.length - 1
      let previousPolaroid = this.currentSeriesPolaroids.shift()
      this.currentSeriesPolaroids.push(previousPolaroid)
      if(this.videoIndex == 0){
        this.videoIndex = slide_length_offset
      } else {
        this.videoIndex--
      }
      /*if (this.polaroidRight < slide_length_offset) {
        this.polaroidLeft++
        this.polaroidRight++
      } else {
        this.polaroidLeft = 0
        this.polaroidRight = this.polaroidDisplayLimit - 1
      }*/
    },
    lightingGallery(index) {
      let el = document.getElementById('lightgallery')
      if (el.getAttribute('lg-uid')) {
        window.lgData[el.getAttribute('lg-uid')].destroy(true)
      }
      console.log(index)
      window.lightGallery(el, {
        mode: 'lg-fade',
        autoplayFirstVideo: true,
        dynamic: true,
        dynamicEl: this.lightboxContent,
        fullScreen: false
      })
      window.lgData[el.getAttribute('lg-uid')].index = index;
      window.lgData[el.getAttribute('lg-uid')].slide(index)
    },
    getTiles(scene) {
      let data = ""
      for (const tiles of scene.tiles.edges) {
        data = data + tiles.node.sku + ", "
      }
      data = data.substring(0, data.length - 2)
      return data
    },
    getSizes(scene) {
      //let data = ""
      let sizes = _.uniq(scene.tiles.edges.map((tile) => {
        return tile.node.shape.size
      }))
      // for (const tiles of scene.tiles.edges) {
      //   data = data + tiles.node.shape.size + ", "
      // }
      // data = data.substring(0, data.length - 2)
      return sizes.join(", ")
    },
  },
  computed: {
    currentSeriesSlides() {
      let slides = []
      if (this.currentSeriesScenes && this.currentSeriesScenes.edges) {
        for (const scene of this.currentSeriesScenes.edges) {
          slides.push(scene.node)
        }
      }
      return slides
    },
    galleryContent() {
      let galleryContent = []
      if (this.currentTileQuery) {
        for (const e of this.currentTileData.tileImages.edges) {
          if(!(e.node.type == 'SHADE_VARIATION_IMAGE')){
            galleryContent.push({
            'id': e.node.id,
            'type': 'image',
            'description': `SKU: ${this.currentTileData.sku} <br /> Series: ${this.currentTileData.series.name} <br /> Color: ${this.currentTileData.color.name} <br /> Shape: ${this.currentTileData.shape.code}`,
            'thumbnail': e.node.publicThumbnail,
            'original_image': e.node.originalImage,
            'large_image': e.node.largeImage,
            'larger_image': e.node.largerImage,
            'url': e.node.originalImage
            })
          }
        }
        for (const e of this.currentTileData.scenes.edges) {
          galleryContent.push({
            'id': e.node.id,
            'type': 'image',
            'description': `SKU: ${this.currentTileData.sku} <br /> Series: ${this.currentTileData.series.name} <br /> Color: ${this.currentTileData.color.name} <br /> Shape: ${this.currentTileData.shape.code}`,
            'thumbnail': e.node.thumbnail,
            'original_image': e.node.originalImage,
            'large_image': e.node.largeImage,
            'larger_image': e.node.largeImage,
            'url': e.node.originalImage
          })
        }
        if (this.currentTileData.series.videoUrl) {
          galleryContent.push({
            'id': this.currentTileData.series.id,
            'type': 'video',
            'youtubeID': this.currentTileData.series.videoYoutubeId,
            'description': `SKU: ${this.currentTileData.sku} <br /> Series: ${this.currentTileData.series.name} <br /> Color: ${this.currentTileData.color.name} <br /> Shape: ${this.currentTileData.shape.code}`,
            'url': this.currentTileData.series.videoUrl,
            'poster': this.currentTileData.series.videoPosterImage
          })
        }
      }
      return galleryContent
    },
    lightboxContent() {
      let data = []
      if (this.currentSeriesPolaroids) {
        for (const element of this.currentSeriesPolaroids) {
          if (element.href) {
            let youtubeID = element.href.split("embed/")
            data.push({
              image: 'img.youtube.com/vi/' + youtubeID[1] + '/0.jpg',
              src: element.href,
              type: 'text/html',
              iframe: true,
              youtube: youtubeID[1],
            })
          }
          else {
            data.push({
              image: element.largeImage,
              subHtml: element.lightboxDescription + "SKU: " + this.getTiles(element) + "<br /> " + "Sizes: " + this.getSizes(element),
              src: element.largeImage,
            })
          }
        }
      }
      return data

      /*      let lightboxContent = []
            for (const e of this.galleryContent) {
              if (e.type =='video') {
                lightboxContent.push({
                  // title: e.description,
                  the_description: e.description,
                  href: e.url,
                  type: 'text/html',
                  youtube: e.youtubeID,
                  poster: e.poster,
                })
              } else {
                lightboxContent.push({
                  image: e.larger_image,
                  // title: e.description,
                  the_description: e.description,
                  href: e.larger_image,
                })
              }
            }
            return lightboxContent*/
    },
    currentTileData() {
      if (this.currentTileQuery) {
        return this.currentTileQuery
      }
      else {
        return {
          id: '',
          sku: '',
          series: {
            name: ''
          },
          color: {
            name: ''
          },
          shape: {
            size: ''
          },
          bodyComposition: '',
          seriesUrl: '',
          literaturePdf: '',
          ecoScoreCardLink: ''
        }
      }
    },
/*    currentTileCountOffset() {
      if (this.resultsPage > 1) {
        return this.tileResults.length + ((this.lastLimit - this.firstLimit) * this.resultsPage) - (this.lastLimit - this.firstLimit)
      }
      else {
        return this.tileResults.length
      }
    },*/
    encodedBookmarks() {
      let bookmarks = []
      for (const bookmark of this.bookmarked_sampleorder_skus) {
        bookmarks.push(this.encodeTileID(bookmark))
      }
      return bookmarks
    },
    uniqueColorLookups() {
      return _.uniq(this.colorLookups)
    },
    totalSamples() {
      return this.orderedQuantityList.reduce((a, b) => a + b, 0)
    },
    orderedQuantityList() {
      let skuList = []
      if (this.quantityUpdated) {
        for (const order of this.sampleOrders) {
          skuList.push((order.quantity) ? order.quantity : 1)
        }
        this.quantityUpdated = false
      }
      return skuList
    },
    groupedTilesForColor() {
      let groupedData = []
      if (this.tilesForColor && this.tilesForColor.edges) {
        groupedData = _.groupBy(this.tilesForColor.edges, (e) => { return e.node.id })
      }
      return groupedData
    },
  },
  mixins: [global_mixin],
  mounted() {
    // if (this.residentialSwitch && !urlParams.has('residential')) {
    //   window.location.href = currentWindowLocation + '?residential=true'
    // }
  },
  watch: {
    windowData: {
      handler: function(val, oldVal) {
        if (this.windowData.width <= 991) {
          if (this.windowData.width <= 767) {
            this.polaroidDisplayLimit = 2
          }
          else {
            this.polaroidDisplayLimit = 3
          }
        }
        else {
          this.polaroidDisplayLimit = 4
        }
        this.polaroidLeft = 0
        this.polaroidRight = this.polaroidDisplayLimit - 1
      },
      immediate: true,
      deep: true
    },
  }
})



// WEBPACK FOOTER //
// ./core/vue/js/series_detail.js